import React, {Component} from 'react';
import "../css/Login.css";
import {Link} from "react-router-dom";
import logo from "../assets/logo_espol_blanco.svg";
import {Alert} from 'react-bootstrap';
import axios from 'axios';
import equis from "../assets/eliminar.svg"
import Modal from '././components/Modal';
//import AdminUsuarios from './AdminUsuarios';
import { Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';


export class Login extends Component{
    
    constructor(props) {

        super(props);

        this.state = {
            datosUsuario:{
                correo: "",
                password: ""
            },
            getDatos:{
                token:"",
                nombres:"",
                apellidos:"",
                identificacion:"",
                rol:""
            },
            show:false,
            showRenderAdminUser:false,
            alert:{
                show:false,
                titulo:"",
                mensaje:"",
                variante:""
            },
			modal:{
                show:false,
                titulo:"",
                mensaje:"",
                imagen:""
            },
            expresiones:{
                correo:/^(\w+[/./-]?){1,}@[a-z]+[/.]\w{2,}([/.]\w{2,})?$/,
            },
            errorSolicitud:{
                correo:"",
                password:"",
            },
        };
        this.cerrarAlert=this.cerrarAlert.bind(this);
		
		this.abrirModal=this.abrirModal.bind(this);
        this.cerrarModal=this.cerrarModal.bind(this);
    }
	
	abrirModal(){
        this.setState({
            modal:{
                ...this.state.modal,
                show:true
            }
        });
    }

    cerrarModal(){
        this.setState({
            modal:{
                titulo:"",
                mensaje:"",
                imagen:"",
                show:false
            }
        });
        //console.log("cerrar modal "+this.state.modal);
    }
	
	
    handlerLogin=async(e)=>{
        await this.setState({
            datosUsuario:{
                ...this.state.datosUsuario,
                [e.target.name]:e.target.value,
            }
        })
        //console.log(this.state.datosUsuario);
        this.handlerOnBlur();

    }

    handlerOnBlur=async()=>{

        /*if(this.state.datosUsuario.correo===""){
            await this.setState({errorSolicitud:{
                ...this.state.errorSolicitud,
                correo: "El campo 'Correo' es requerido"
            }})
        }else */
        if(!this.state.expresiones.correo.test(this.state.datosUsuario.correo)){
            await this.setState({errorSolicitud:{
                ...this.state.errorSolicitud,
                correo: "El campo 'Correo' no tiene formato correcto"
            }})
        }else{
            this.setState({errorSolicitud:{
                ...this.state.errorSolicitud,
                correo:""
            }})
        }

        if(this.state.datosUsuario.password===""){
            await this.setState({errorSolicitud:{
                ...this.state.errorSolicitud,
                password: "El campo 'Contraseña' es requerido"
            }})
        }else{
            this.setState({errorSolicitud:{
                ...this.state.errorSolicitud,
                password:""
            }})
        }

    }

    iniciarSesion=async(e)=>{
        e.preventDefault();

        let credenciales ={
            username:this.state.datosUsuario.correo.split("@")[0],
            password:this.state.datosUsuario.password,
            correo:this.state.datosUsuario.correo
        } 
        //console.log(credenciales);
        

        if(this.state.datosUsuario.correo===""||this.state.datosUsuario.password===""){
            this.setState({
                alert:{
                    show:true,
                    titulo:"Error en la solicitud",
                    mensaje:"Campos vacios",
                    variante:"danger"
                }                
            })
            //console.log("alerta vacios");
        }else{
            await axios.post(`${process.env.REACT_APP_API}api/CuentaUsuario/login`,credenciales)
            .then(r=>{
                //console.log(r);
                if(r.data.persona.rol==="Admin"){
                    this.props.setValue(true);
                    Cookies.set("token",JSON.stringify(r.data.token),  { expires: 1 });
                    Cookies.set("rol",JSON.stringify(r.data.persona.rol),  { expires: 1 });
                    Cookies.set("nombres",JSON.stringify(r.data.persona.nombres),  { expires: 1 });
                    Cookies.set("apellidos",JSON.stringify(r.data.persona.apellidos),  { expires: 1 });
                    Cookies.set("identificacion",JSON.stringify(r.data.persona.identificacion),  { expires: 1 });

                    this.setearHeader();
                    this.setState({showRenderAdminUser:true})
                }
            })
            .catch(error=>{
                this.setState({
                    // alert:{
                        // show:true,
                        // titulo:"Error en la solicitud",
                        // mensaje:"Usuario y/o contraseña incorrectos",
                        // variante:"danger"
                    // }   
					modal:{
                        show:true,
                        titulo:"Error en la solicitud",
                        mensaje:"Correo o contraseña incorrecta",
                        imagen:equis
                    }
                })
                //console.log(error.message);
            })
        }
    }

    setearHeader(){
        //console.log("setear header");
        var token = JSON.parse(Cookies.get("token"));
        if (token) {
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        } else {
            axios.defaults.headers.common['Authorization'] = null;

        }

    }

    cerrarAlert(){
        this.setState({show:false})
    }

    render(){
        return(

            this.state.showRenderAdminUser? <Navigate to="/usuarios"/>:
            <div className="container-fluid" id="fondo">

                
                {
                    this.state.show&&
                    <Alert variant={this.state.alert.variante} onClose={this.cerrarAlert} dismissible>
                        <Alert.Heading>{this.state.alert.titulo}</Alert.Heading>
                        <p>
                        {this.state.alert.mensaje}.
                        </p>
                    </Alert>
                }


                <div className="login-wrapper">
                    <div className="login-container" >
                    
                        <div className='login-header'>
                            <img className='logo' src={logo} alt="Logo espol" ></img>
                        </div>                        
                        <div className="login-body">
                            <form onSubmit={this.iniciarSesion}>
                                <div className="mb-3">
                                    <label htmlFor="correo" className="form-label">Usuario:</label>
                                    <input 
                                    type="text" 
                                    required 
                                    className="form-control" 
                                    id="correo" 
                                    placeholder="Correo electrónico" 
                                    name="correo" 
                                    value={this.state.datosUsuario.correo} 
                                    onChange={this.handlerLogin}/>
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="password" className="form-label">Contraseña:</label>
                                    <input 
                                    type="password" 
                                    required 
                                    className="form-control" 
                                    id="password" 
                                    placeholder="Contraseña" 
                                    name="password" 
                                    value={this.state.datosUsuario.password} 
                                    onChange={this.handlerLogin}
                                    onBlur={this.handlerOnBlur}
                                    />
                                </div>
                                
                                <div className="containerSecundario">
                                    <p> <Link className="link" to="/olvidoContrasenia">¿Olvidó su contraseña?</Link></p>
                                </div>

                                <div className="containerIniciarSesion">
                                    <button 
                                    type="submit" 
                                    className="btn-submit-login"
                                    disabled={this.state.datosUsuario.correo &&
                                        this.state.datosUsuario.password&&
                                        !this.state.errorSolicitud.correo&&
                                        !this.state.errorSolicitud.password
                                        ? false:true}
                                    >
                                        INICIAR SESIÓN
                                    </button>            
                                    <p className='mt-4'>¿Eres nuevo? <Link className="link" to="/registro">Regístrate</Link></p>
                                    <p className='mt-4'><Link className="link" to="/cambiarContrasenia">Cambiar contraseña</Link></p>
                                </div>
                            </form>
                        </div>
						
						{this.state.modal.show&& 
                        <Modal isOpen={this.state.modal.show} cerrarModal={this.cerrarModal} verBoton={true} textoBoton="ACEPTAR" >
                            <p className='text-center'><strong>{this.state.modal.titulo}</strong></p>
                            <div className='mt-6 mb-6'>
                                <img className="registroContra-check" src={this.state.modal.imagen} alt="Error"></img>
                            </div>

                            <p className='text-center'>{this.state.modal.mensaje}</p>
                            
                        </Modal>}
						
                        <div className="linea"></div>

                    </div>                             
                </div>
            </div>
            
            
        )
    }
}

export default Login
